<ng-container>
  <ng-container *ngTemplateOutlet="mobile ? mobileView : desktopView">
  </ng-container>
</ng-container>

<ng-template #desktopView>
  @if (visible) {
    <div id="cart-select" class="app-cart-select">
      <strong>{{ label }}: </strong>
      <ng-select
        id="cart-select-dropdown"
        class="order-select font-5"
        placeholder="Select an Order to Make Active"
        [items]="orders"
        bindValue="id"
        [searchable]="false"
        [clearable]="false"
        (change)="onSelectOrder($event)"
        name="order"
        [(ngModel)]="selectedID"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ getOrderLabel(item) }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ getOrderLabel(item) }}
        </ng-template>
      </ng-select>
      @if (allowAdd) {
        <button
          id="add-order-btn"
          (click)="onAddOrder()"
          type="button"
          class="btn btn-outline-primary"
        >
          {{ buttonLabel }}
        </button>
      }
      <!-- this is workaround after mobix to rxjs -->
      <div class="invisible" hidden>{{ getterOrders }}</div>
    </div>
  }
</ng-template>
<ng-template #mobileView>
  @if (visible) {
    <div id="cart-select-mobile" class="d-flex align-items-center">
      <ng-select
        id="cart-select-dropdown-mobile"
        class="order-select font-5 mobile"
        placeholder="Select an Order to Make Active"
        [items]="orders"
        bindValue="id"
        [searchable]="false"
        [clearable]="false"
        (change)="onSelectOrder($event)"
        name="order"
        [(ngModel)]="selectedID"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ getOrderLabel(item) }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ getOrderLabel(item) }}
        </ng-template>
      </ng-select>
      @if (allowAdd) {
        <button
          id="add-order-btn-mobile"
          (click)="onAddOrder()"
          type="button"
          class="btn btn-outline-primary ms-3"
        >
          CREATE
        </button>
      }
      <!-- this is workaround after mobix to rxjs -->
      <div class="invisible" hidden>{{ getterOrders }}</div>
    </div>
  }
</ng-template>
